import { SpeakerWithDetails } from '@goldcast/player-config/src/types/speaker-types';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';
import Icon from '@/components/atoms/Icon';

export default function EmptyProfilePicturePlaceHolder({
  previewOnly = false,
  speaker
}: {
  previewOnly?: boolean;
  speaker?: SpeakerWithDetails;
}) {
  function openContentSettings() {
    if (!previewOnly) {
      EventBus.dispatch(CustomEvents.OpenContentSettings, { speakerId: speaker?.id });
    }
  }
  return (
    <div
      className="flex size-full flex-col items-center justify-center gap-2 bg-slate-200 text-center text-sm text-slate-500"
      data-testid="placeholder-container"
    >
      <Icon name="IconPhoto" size={previewOnly ? 8 : 28} />
      {!previewOnly && (
        <p className="max-w-36">
          Add a speaker image in the
          <span className="pointer-events-auto cursor-pointer underline" onClick={openContentSettings}>
            {' '}
            settings{' '}
          </span>
          menu
        </p>
      )}
    </div>
  );
}
